import { useState } from "react";

import { FreelancerDashboardJobsLazy } from "../../lazy";
import { MyWorkListingPage } from "../my-work-listing-page";

export const DashboardMyJobsPage = () => {
  const [showClosedJobs, setShowClosedJobs] = useState(false);

  const checkboxProps = {
    checkboxText: "Show past jobs",
    isChecked: showClosedJobs,
    setIsChecked: setShowClosedJobs,
  };

  return (
    <MyWorkListingPage pageTitle="Jobs History" checkboxProps={checkboxProps}>
      <FreelancerDashboardJobsLazy showClosedJobs={showClosedJobs} />
    </MyWorkListingPage>
  );
};
